import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {
	
    sessionStorage.getItem("SmithPro_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
   

   if(sessionStorage.getItem("OandRSmithPro_Action")=="Add")
   {
	    setSaveButtonText("Save");
      setProNo("{Auto}");
     
      //Clear();
   
   }
   else if(sessionStorage.getItem("OandRSmithPro_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("OandRSmithPro_EditId"));
   }
   else if(sessionStorage.getItem("OandRSmithPro_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("OandRSmithPro_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }

  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtSmith, setdtSmith]=useState([]);
  const [dtOrder, setdtOrder]=useState([]);
  const [dtOrderOrg, setdtOrderOrg]=useState([]);
  const [TMshow1, setTMShow1] = useState(false);
  const TMhandleClose1 = () => setTMShow1(false);
  const [SearchTxt, setSearchTxt, SearchTxtRef] = useStateRef('');

  const [LoadButtonHide,setLoadButtonHide]=useState(false);

  const [btndisabled, setDisabled] = useState('disabled');
  

  const [DtSaleDetTable, setDtSaleDetTable, DtSaleDetTableRef]=useStateRef([]);
  let SaleDetTable=[];

 
  const [Salesshow1, setSalesshow1] = useState(false);
  const SaleshandleClose1 = () => setSalesshow1(false);
  const SaleshandleShow1 = () => setSalesshow1(true);
  
  const [Txt, setTxt, TxtRef] = useStateRef(0);
  
   const [ProNo, setProNo, ProNoRef] = useStateRef(0);
   const [ProDate, setProDate, ProDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   
//order Detail
const [SaleId,setSaleId,SaleIdRef]=useStateRef('');
   
const [SmithName,setSmithName,SmithNameRef]=useStateRef('');
   
async function setCheck(id,ex)
{


  try
{
 
  var cnt = 0;
  try {
      cnt = dtOrder.length;
  }
  catch (err) {
      cnt = 0;
  }

  let i=0;

  for (i = 0; i < cnt; i++) {
      if (dtOrder[i].OrderId == id) {
        dtOrder[i].Checked=ex.checked;
      }
    }
setTxt('');



}
catch (error) {
  console.log(error);
}

 


}

async function AddSmithName(id,smithname)
{


  try
{
 

  SaleDetTable=DtSaleDetTable;

  var cnt = 0;
  try
  {
      cnt = SaleDetTable.length;       
  }
  catch(err)
  {
      cnt=0;
  }

  
  let i=0;

  for (i = 0; i < cnt; i++) {
      if (SaleDetTable[i].ID == id) {
        SaleDetTable[i].SmithName=smithname;
      }
    }
setTxt('');


setDtSaleDetTable(SaleDetTable);


}
catch (error) {
  console.log(error);
}

 


}


function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}


function SearchFun(text)
{
  setdtOrder(dtOrderOrg.filter(function (x) {
    return x.OrderId.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  



async function ControlSettings()
{

  document.getElementById("txtBillNo").disabled ='true';
  
  
  if((sessionStorage.getItem("OandRSmithPro_Action")=="Edit") || (sessionStorage.getItem("OandRSmithPro_Action")=="Delete"))
   {
  
   

   }

 



}




async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    
  setLoadButtonHide(true);

    const results = await apiService.postCall("smithpro/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let SalesDetail=results.data.SalesDetail;
   
  

  if(SalesDetail[0].length>0)
   setDtSaleDetTable(SalesDetail[0]);


   
      setProNo(HeadData[0][0].ProNo);
      setProDate(HeadData[0][0].ProDate);
      

   getLookup();



     
     

     
       
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
		let postData = {
			"Action" : sessionStorage.getItem("OandRSmithPro_Action"),
			"EditId" : sessionStorage.getItem("OandRSmithPro_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "ProNo":ProNoRef.current,
      "ProDate":ProDateRef.current,
      "DtSaleDetTable":DtSaleDetTableRef.current,
      }

    let ErrMsg="";



    SaleDetTable=DtSaleDetTable;

    var cnt = 0;
    try
    {
        cnt = SaleDetTable.length;       
    }
    catch(err)
    {
        cnt=0;
    }



    var i=0;

    for (i = 0; i < cnt; i++) {
      if(SaleDetTable[i].SmithName=="")
      {
        ErrMsg="Please Select Smith";
        break;
      }

    }
    
    if(postData.DtSaleDetTable.length==0)
    {
      ErrMsg="Please Enter Propose Details";
    }

if(ErrMsg=="")
{
    const results = await apiService.postCall("smithpro/Save",postData);

    if (results != "-1") {

if(results.errorCode=="8888")
{
  swal({

    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });
  return;
}  

  if(sessionStorage.getItem("OandRSmithPro_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("OandRSmithPro_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("OandRSmithPro_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
}

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "info",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }


async function SalesgridEdit (id) {

     

  SaleDetTable=DtSaleDetTable;

  var cnt = 0;
  try {
      cnt = SaleDetTable.length;
  }
  catch (err) {
      cnt = 0;
  }




  let i=0;

  for (i = 0; i < cnt; i++) {
      if (SaleDetTable[i].ID == id) {

        setSaleId(id);
        setSmithName(SaleDetTable[i].SmithName);
  
          break;

      }          
  }

  setDtSaleDetTable(SaleDetTable);

  SaleshandleShow1();

}


 async function SalegridRemove (id) {


  
    SaleDetTable=DtSaleDetTable;
     
      var cnt = 0;
      try {
          cnt = SaleDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((SaleDetTable[i].ID == id))
          {
            SaleDetTable.splice(i, 1);
              break;
          }
      }

      setDtSaleDetTable(SaleDetTable);
    
    setSmithName('');
    
    
    //Clear();

  }

  async function SalesClear()
   {
    
    if((SmithNameRef.current.length>0))
    {
    setSmithName('');

  }
  else
  {
  

    SaleshandleClose1();
	}
    


	 	
   }


async function gridAdd () {


  let slno=SaleIdRef.current;
  let SmithName1=SmithNameRef.current;
 


if ((SmithName1.length>0))
{
    SaleDetTable=DtSaleDetTable;

    var cnt = 0;
    try
    {
        cnt = SaleDetTable.length;       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {

      

        if ((SaleDetTable[i].ID == slno)) {
          SaleDetTable[i].SmithName=SmithName1;
    
          //SalesClear();
          //SaleshandleClose1();

     

            found = true;
            break;
        }
        else {


         

     
        }
    }
           
    setSalesshow1(false);
  
  setDtSaleDetTable(SaleDetTable);
  setSaleId('');
  setSmithName('');


  

}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}




async function LoadOrder(){
  setTMShow1(true);
 }


 async function GetOrderDetail(){
  try {		
   

    var cnt = 0;
    try {
        cnt = dtOrder.length;
    }
    catch (err) {
        cnt = 0;
    }
 
  let i=0;

  var OrderTxt="";
    for (i = 0; i < cnt; i++)
    {
        if ((dtOrder[i].Checked == true))
        {
          if(OrderTxt=="")
          OrderTxt="'"+dtOrder[i].OrderId+"'";
          else
          OrderTxt=OrderTxt + ",'"+dtOrder[i].OrderId+"'";
          
        }
      }

      if(OrderTxt=="")
      OrderTxt="''"

    
   let postData = {
     "OrderTxt" : OrderTxt
   };
   
   const results = await apiService.postCall("smithpro/getOrderDetail",postData);

  if (results != "-1") {

   setDtSaleDetTable(results.data[0][0]);
   setTMShow1(false);

     }

   } catch (error) {
     console.log(error);
   }
}


  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : 0
    };
		
    const results = await apiService.postCall("smithpro/Lookup",postData);

	 if (results != "-1") {

    setdtSmith(results.data[0][0]);
    setdtOrder(results.data[1][0]);
    setdtOrderOrg(results.data[1][0]);
   

    
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/oandr/smithpro/list');
  };


  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

              
                <div className='row'>
                  <div className='col-lg-6'>
                       
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Propose No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtBillNo" placeholder="" value={ProNo}  />
                          </div>
                         
                          <div className='col-md-6'>
                            <Form.Label>Propose Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtBillDate" placeholder="" value={ProDate} onChange={(e)=>setProDate(e.target.value)} />
                          </div>
                          <div className='col-md-6'>
                          <Button type="button" className="detbutton" id="cmdDetSave" hidden={LoadButtonHide}  variant="btn btn-primary" onClick={LoadOrder}>Load</Button>
                                             </div>
						  

</div>
</div>


                  </div>
                 
                  <div className='row'>
                  <div className='col-lg-12'>
                    
           
    <div className="table-responsive mt-4" >
			 
      
       	   
       <Table striped id="basic-table" className=" " role="grid">
         <thead>
           <tr>
            <th > Edit</th>
             <th>Order No</th>
             <th>Customer</th> 
             <th>Description</th>
             <th>Size</th>
             <th>Pcs</th>
             <th>GrossWt</th>  
             <th>Smith</th>  
            
   <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtSaleDetTable.map((item) => (
           <tr>
              <td >
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>SalesgridEdit(item.ID)}  >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.OrderId}</td>
             <td>{item.CustomerName}</td>
             <td>{item.ItemName}</td>                 
             <td>{item.SizeName}</td>
             <td>{item.Pcs}</td>
             <td>{item.GrossWt}</td>  
             <td>{item.SmithName} 
             
      

       </td>  
            
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>SalegridRemove(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
   )
   )
    }     
         </tbody>
       </Table>
<div className="EntryPan" hidden="true">

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#"  onClick=
                              {
                                (e) => {
                              setSaleId('');
                              SaleshandleShow1();
                                }
                                } >
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>




</div>



                         
                         
     </div>
     
     
   
      <div className='row'>
      <div className='col-lg-3'>
     
   
</div>




       




  
     </div>

    
  
    

                     
                     
                    
                  </div>
              </div>
              </div>


              <Modal show={Salesshow1}  className=".modal-xl"  >
                  <Modal.Header >
                    <Modal.Title>Select Smith Name</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                            <div className='col-md-12'>

        <Form.Label>Smith</Form.Label>
         <Select className="form-select-search" 
       options={dtSmith}
       value={dtSmith.filter(function(option) {
        return option.value === SmithName;
      })}
      onChange=
      {
        (e) => {
      setSmithName(e.value);
        }
        }
       disabled={false}>
       </Select>
       

     
      </div>

  

                       

</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={gridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={SalesClear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				


             	
              <Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Control type="text" placeholder='Order No' value={SearchTxt} onChange={(e)=> { 
                      setSearchTxt(e.target.value)
                      SearchFun(e.target.value)
                      }}/>
                  </Modal.Header>

                  <Modal.Body>
                    
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable1" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Order No</th>
             <th>Customer</th>
             <th>Description</th>   
             <th>Pcs</th>              
             <th>GrossWt</th>              
             
           </tr>
         </thead>
         <tbody>
         {dtOrder.map((item) => (
           <tr>
            
   <td>  
    
     <Form.Check className="me-2">
                               
                               <Form.Check.Input type="checkbox" name="g1" onChange={(e) => setCheck(item.OrderId,e.target)}  className="lstItems" id={item.OrderId} />
                               
                               <Form.Check.Label>{item.OrderId}</Form.Check.Label>
                             </Form.Check>
                             </td>
         
             
            
             <td>{item.CustomerName}</td>
             <td>{item.ItemName}</td>
             <td>{item.Pcs}</td>
             <td>{item.GrossWt}</td>
            


           </tr>
             )
             )
              }     
         </tbody> 
       </Table>
      
     </div>

					 </Modal.Body>
           <Modal.Footer>
           <Button type="button" variant="btn btn-primary" onClick={GetOrderDetail}>OK</Button> {' '}
            </Modal.Footer>
                 </Modal>
				
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
